import type { ReactElement } from 'react';

import { Box } from '../Box/Box';
import { radioButtonGroupContext } from './lib/context';
import type { RadioButtonGroupItemProps } from './RadioButtonGroupItem';

interface RadioButtonGroupProps {
  name: string;
  value?: string;
  onChange: (selectedValue: string) => void;
  children: ReactElement<RadioButtonGroupItemProps>[];
}

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({ name, value, onChange, children }) => {
  return (
    <radioButtonGroupContext.Provider value={{ name, value, onChange }}>
      <Box display="flex">{children}</Box>
    </radioButtonGroupContext.Provider>
  );
};
